import { render } from "./ammolite.vue?vue&type=template&id=af808060&scoped=true"
import script from "./ammolite.vue?vue&type=script&lang=js"
export * from "./ammolite.vue?vue&type=script&lang=js"

import "./ammolite.vue?vue&type=style&index=0&id=af808060&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af808060"

export default script